/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingdeleted1Inputs */

const en_listingdeleted1 = /** @type {(inputs: Listingdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing deleted`)
};

const de_listingdeleted1 = /** @type {(inputs: Listingdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort gelöscht`)
};

/**
* | output |
* | --- |
* | "Listing deleted" |
*
* @param {Listingdeleted1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingdeleted1 = /** @type {((inputs?: Listingdeleted1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingdeleted1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingdeleted1(inputs)
	return de_listingdeleted1(inputs)
});
export { listingdeleted1 as "listingDeleted" }